import { compose, withProps, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { getCharitySelector, makeCharityContactsSelector } from './selectors'
import { fetchCharity, fetchCharityContacts } from './actions'
import withCharitySocialMedia from './withCharitySocialMedia'
import withTranslations from '../../core/withTranslations'
import CharityContact from '../../ui/views/charity-contact'

const translations = withTranslations({
  contactText: 'charity.contact.contact',
  websiteText: 'charity.contact.website',
  contactWithUsText: 'charity.contact.contactWithUs'
})

const mapStateToProps = (state, props) => {
  const charityId = Number(props.match.params.id)
  const charity = getCharitySelector(charityId)(state)
  const contacts = makeCharityContactsSelector(charityId)(state)
  return { charityId, charity, contacts }
}
const withCharityData = connect(mapStateToProps, {
  fetchCharity,
  fetchCharityContacts
})

const fetchOnMount = lifecycle({
  componentDidMount() {
    const {
      charityId,
      charity,
      fetchCharity,
      contacts,
      fetchCharityContacts
    } = this.props
    if (!charity) fetchCharity(charityId)
    if (!contacts.length) fetchCharityContacts(charityId)
  }
})

const withFormattedProps = withProps(
  ({ charity, contacts, contactText, websiteText, contactWithUsText }) => ({
    charityName: charity && charity.name,
    charityLink: charity && `/charities/${charity.id}`,
    charityWebsite: charity && charity.website
  })
)

export const CharityContactEnhancer = compose(
  translations,
  withCharityData,
  fetchOnMount,
  withFormattedProps,
  withCharitySocialMedia
)

export default CharityContactEnhancer(CharityContact)



// WEBPACK FOOTER //
// ./src/services/charity/CharityContact.js